<template>
  <div id="AboutMeCollage2" style="width: 90%; padding-bottom: 18%;">
    <img
      fetchpriority="high"
      class="content"
      style="width: 40%;"
      src="/static/about-me/i5.webp"
    />
    <div>
      <img
        fetchpriority="high"
        style="width: 35%; translate: -7% -10%;  scale: 0.9;"
        src="/static/about-me/i6.webp"
      />
      <img
        fetchpriority="high"
        style="width: 30%; translate: -8% 30%; scale: 0.9;"
        src="/static/about-me/i7.webp"
      />
      <img
        fetchpriority="high"
        style="width: 25%; translate: -2% -10%;"
        src="/static/about-me/i8.webp"
      />
    </div>
    <div class="content">
      <img
        fetchpriority="high"
        style="width: 33%; translate: 7% 17%; z-index: 1;"
        src="/static/about-me/i9.webp"
      />
      <StickMe
        name="50"
        size="17"
        left="58"
        top="72"
        uk-parallax="scale: 1.1"
        style="z-index: 2;"
      />
      <img
        fetchpriority="high"
        style="width: 30%; translate: 25% 48%; scale: 0.9; z-index: 2;"
        src="/static/about-me/i11.webp"
      />
    </div>
    <img
      fetchpriority="high"
      style="width: 33%; translate: -9% 44%; scale: 0.9;"
      src="/static/about-me/i10.webp"
    />

    <StickMe name="13" size="16" left="26" top="-1" uk-parallax="x: 30%" />
    <StickMe name="45" size="16" left="24" top="13" style="z-index: -1;" />
    <StickMe name="3" size="8" left="7" top="6" uk-parallax="x: 50%" />

    <StickMe name="13" size="12" left="4" top="26" uk-parallax="x: -30%" />

    <StickMe name="46" size="22" left="86" top="14.1" style="z-index: -1;" />
    <StickMe name="5" size="11" left="71" top="16" uk-parallax="x: 10%" />

    <StickMe name="101" size="16" left="54" top="25.5" />

    <StickMe name="3" size="22" left="8" top="43" uk-parallax="x: 20%" />
    <StickMe name="48" size="18" left="33" top="48" style="z-index: 0;" />
    <StickMe name="47" size="14" left="73" top="41" />
    <StickMe name="28" size="5" left="68" top="49" uk-parallax="y: 20%" />
    <StickMe name="3" size="22" left="85" top="58" uk-parallax="x: 40%" />
    <StickMe name="13" size="19" left="56" top="56" />
    <StickMe name="100" size="18" left="17" top="69" style="z-index: -1;" />
    <StickMe name="49" size="19" left="8" top="63" />
    <StickMe
      name="51"
      size="15"
      left="92"
      top="67"
      uk-parallax="x: 10%"
      style="z-index: -1;"
    />
    <StickMe name="3" size="15" left="66" top="86" uk-parallax="x: 90%" />
  </div>
</template>

<script>
import StickMe from './StickMe.vue'

export default {
  components: {
    StickMe,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeCollage2.vue